module.exports = __webpack_public_path__ + "static/media/ic-info.ee2dc7e7.svg";